export default {
  SET_THEME(state, data) {
    state.theme = data;
  },
};
